/* ACTIONS */
export const ACCEPT_COOKIES = "ACCEPT_COOKIES";
export const SHOW_LOADING = "SHOW_LOADING";
export const HIDE_LOADING = "HIDE_LOADING";

/* end ACTIONS */
